module.exports = __webpack_public_path__ + "static/media/punjab-logo.7098d15d.png";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/assets/images/punjab-logo.png
// module id = 2259
// module chunks = 1137